import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CreateUserModel } from '../../../../models/createUserModel';
import { CreateUserResult } from '../../../../models/createUserResult';
import { EnrollmentService } from '../../../../services/enrollment.service';
import { SnackbarService } from '../../../../services/snackbar.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddUserComponent implements OnInit {
  language = [{ value: 'svenska', viewValue: 'Svenska' }];
  public createUserModel: CreateUserModel = new CreateUserModel(null);
  matcher = new MyErrorStateMatcher();
  createUserForm = new UntypedFormGroup({
    language: new UntypedFormControl(''),
    firstname: new UntypedFormControl('', Validators.required),
    lastname: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });

  constructor(
    public _snackBar: SnackbarService,
    private dialogRef: MatDialogRef<AddUserComponent>,
    public enrollmentService: EnrollmentService
  ) {}

  ngOnInit() {
    // console.log(this.createUserForm.value);
    // console.log(this.createUserForm.controls['language'].value);
  }

  createNewUser() {
    this.enrollmentService
      .createUser(
        this.createUserForm.controls['email'].value,
        this.createUserForm.controls['firstname'].value,
        this.createUserForm.controls['lastname'].value,
        this.createUserForm.controls['language'].value
      )
      .subscribe(
        result => {
          const test = result;
          console.warn('USER CREATED', this.createUserForm.value);
          if (result.success) {
            this.createUserModel = new CreateUserModel(null);
            this._snackBar.openSnackBar('Användare skapad', 'OK');
          } else {
            this._snackBar.openSnackBar(
              'Något gick fel, vänligen kontrollera dina uppgifter',
              'OK'
            );
          }
        },
        (error: CreateUserResult) => {
          console.log(error);
          this._snackBar.openSnackBar('Något gick fel', 'OK');
        }
      );
  }

  cancelForm() {
    this.dialogRef.close();
  }
}
